<div
	class="
		flex-auto flex-grow-0 flex-shrink-0
		p-border-color-component-background p-1
		border border-solid border-t-0 border-r-0 border-l-0
	"
>
	<input
		[ngModel]="controller.searchTerm$ | async"
		[placeholder]="'presentation.app.sidebar.coachees.search.ph' | translate"
		(ngModelChange)="onSearchTermChange($event)"
		class="w-full"
		pInputText
	/>
</div>
<div class="flex-auto relative">
	<ng-scrollbar
		class="absolute w-full h-full top-0 left-0"
		track="vertical"
		visibility="hover"
	>
		<div
			*ngFor="let coachee of controller.coachees$ | async; trackBy: trackByCoachee"
			class="flex flex-row p-3 relative items-center"
		>
			<a
				[routerLink]="['/coachee', coachee.entity.id]"
				class="flex items-center space-x-3 leading-10"
			>
				<div
					[class.border-2]="chatUserId === coachee.entity.id"
					[class.border-solid]="chatUserId === coachee.entity.id"
					[sprBadge]="coachee.pendingMessages > 99 ? 99 : coachee.pendingMessages"
					[style.backgroundImage]="coachee.entity.cssPictureUrl"
					class="
						w-10
						h-10
						bg-cover bg-center
						text-center
						rounded-full
						p-border-color-secondary p-background-color-primary-variant-pastel
					"
				>
					<ng-container *ngIf="!coachee.entity.cssPictureUrl">
						{{ coachee.entity.acronym }}
					</ng-container>
				</div>
				<div class="flex-auto font-semibold truncate overflow-hidden">
					{{ coachee.entity.name }}
				</div>
			</a>
			<p-speedDial
				[mask]="true"
				[model]="coachee.menu"
				buttonClassName="p-button-link p-0"
				className="right-3 top-1/2 -translate-y-1/2"
				direction="left"
				hideIcon="fas fa-ellipsis-h"
				radius="60"
				showIcon="fas fa-ellipsis-v"
			></p-speedDial>
		</div>
	</ng-scrollbar>
</div>
